import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const BuyersListSearchParamsSchema = createPaginationSchema().concat(
  createSortSchema(['name', 'town', 'county', 'initiative'], { defaultSortBy: 'name' })
);
